import React from 'react';
import classSet from 'react-classset';

const CircleMeter = ({showing, progress, transitionDuration}) => {

  const meterClasses = classSet({
    "ssc__circle-meter": true,
    "ssc__circle-meter--showing": showing
  });

  let circleRadius = 47,
      circleCircumference = 2 * Math.PI * circleRadius,
      circlePathOffset = circleCircumference - circleCircumference * progress;

  if(progress === 0){
    circlePathOffset = circleCircumference;
  }

  return (

    <div className={meterClasses}>
      <svg className="ssc__circle-meter__svg" width="120" height="120" viewBox="0 0 100 100">
        <circle
        	className="ssc__circle-meter__svg__circle"
        	cx="50"
        	cy="50"
        	r={circleRadius}
        />
        <circle
          style={{transitionDuration: transitionDuration}}
          className="ssc__circle-meter__svg__circle__fill"
          cx="50"
          cy="50"
          r={circleRadius}
          strokeDasharray={circleCircumference}
          strokeDashoffset={circlePathOffset}
        />
      </svg>
    </div>

  );

}

export default CircleMeter;


// WEBPACK FOOTER //
// ./src/components/CircleMeter/CircleMeter.js